/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import EventDispatcher = alm.event.EventDispatcher;
	import Hash = alm.util.Hash;

	export class AudioPlayer extends EventDispatcher {

		// Singleton
		public static getInstance():AudioPlayer { return AudioPlayer.instance || (AudioPlayer.instance = new AudioPlayer()); }
		private static instance:AudioPlayer = null;





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
			super();

			const AudioContext:any = window['AudioContext'] || window['webkitAudioContext'] || null;
			this.isAvailable = AudioContext != null;
			if (this.isAvailable) {
				this.context = new AudioContext();
				this.clipsById = {};

				this.masterGainNode = this.context.createGain();
				this.masterGainNode.connect(this.context.destination);
				this.masterVolume = 1;
			}
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public load(url:string, masterVolute:number = 1, id:string = ''):boolean {
			if (!this.isAvailable) return false;
			if (id == '') id = url;
			if (this.clipsById[id]) return false;
			this.clipsById[id] = new AudioClip(this.context, this.masterGainNode, url, masterVolute);
			return true;
		}

		public getClip(id:string):AudioClip {
			if (!this.isAvailable) return;
			return this.clipsById[id];
		}

		/*
		public play(id:string, loop:boolean = false, overwrite:boolean = true):void {
			if (!this.isAvailable) return;
			const clip:AudioClip = this.clipsById[id];
			if (clip) clip.play(loop, overwrite);
		}

		public stop(id:string):void {
			if (!this.isAvailable) return;
			const clip:AudioClip = this.clipsById[id];
			if (clip) clip.stop();
		}

		public getVolume(id:string):number {
			if (!this.isAvailable) return 0;
			const clip:AudioClip = this.clipsById[id];
			return clip ? clip.getVolume() : 0;
		}

		public setVolume(id:string, volume:number):void {
			if (!this.isAvailable) return;
			const clip:AudioClip = this.clipsById[id];
			if (clip) clip.setVolume(volume);
		}

		public fadeTo(id:string, to:number, duration:number = 1000):void {
			if (!this.isAvailable) return;
			const clip:AudioClip = this.clipsById[id];
			if (clip) clip.fadeTo(to, duration);
		}

		public fadeIn(id:string, duration:number = 1000):void {
			if (!this.isAvailable) return;
			const clip:AudioClip = this.clipsById[id];
			if (clip) clip.fadeIn(duration);
		}

		public fadeOut(id:string, duration:number = 1000, stopOnComplete:boolean = true):void {
			if (!this.isAvailable) return;
			const clip:AudioClip = this.clipsById[id];
			if (clip) clip.fadeOut(duration, stopOnComplete);
		}
		*/

		public getMasterVolume():number {
			if (!this.isAvailable) return 0;
			return this.masterVolume;
		}

		public setMasterVolume(volume:number):void {
			if (!this.isAvailable) return;
			this.masterVolume = volume;
			this.masterGainNode.gain.value = this.masterVolume;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isAvailable:boolean;
		private context:AudioContext;
		private clipsById:Hash<AudioClip>;

		private masterGainNode:GainNode;
		private masterVolume:number;
	}
}
